import * as React from 'react'
import type {SVGProps} from 'react'
const SvgExpand = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={32}
        height={32}
        fill="none"
        viewBox="0 0 32 32"
        {...props}
    >
        <circle cx={16} cy={16} r={16} fill="#142745" />
        <path
            fill="#fff"
            d="M13.142 8.727c.432 0 .78.348.78.78 0 .431-.348.779-.78.779h-2.857v2.857c0 .432-.347.78-.78.78a.777.777 0 0 1-.778-.78V9.507c0-.432.347-.78.779-.78zm-4.415 10.13c0-.432.347-.78.779-.78s.779.348.779.78v2.857h2.857c.432 0 .78.348.78.78 0 .431-.348.779-.78.779H9.506a.777.777 0 0 1-.78-.78zm13.766-10.13c.432 0 .779.348.779.78v3.636c0 .432-.347.78-.78.78a.777.777 0 0 1-.778-.78v-2.857h-2.858a.777.777 0 0 1-.779-.78c0-.431.348-.779.78-.779zm-.78 10.13c0-.432.348-.78.78-.78s.779.348.779.78v3.637c0 .431-.347.779-.78.779h-3.636a.777.777 0 0 1-.779-.78c0-.431.348-.779.78-.779h2.857z"
        />
    </svg>
)
export default SvgExpand
